// extracted by mini-css-extract-plugin
module.exports = {"ctoButton":"CellularCapability_ctoButton__2kUmX","noHoverBg":"CellularCapability_noHoverBg__2AUMm"};